// extracted by mini-css-extract-plugin
module.exports = {"copyUrlPopover":"CopyUrl_copyUrlPopover__CbJop","active":"CopyUrl_active__zJH4v","copyUrlButton":"CopyUrl_copyUrlButton__k4T0_"};